import { render, staticRenderFns } from "./PopUpGeneratedReoports.vue?vue&type=template&id=ffae78f4&"
import script from "./PopUpGeneratedReoports.vue?vue&type=script&lang=ts&"
export * from "./PopUpGeneratedReoports.vue?vue&type=script&lang=ts&"
import style0 from "./PopUpGeneratedReoports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ffae78f4', component.options)
    } else {
      api.reload('ffae78f4', component.options)
    }
    module.hot.accept("./PopUpGeneratedReoports.vue?vue&type=template&id=ffae78f4&", function () {
      api.rerender('ffae78f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/OrdenesServicio/PopUpGeneratedReoports.vue"
export default component.exports